var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#123862"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.42 47.829-.05.05c-.68-1.484-1.108-3.17-1.284-5.032a15.454 15.454 0 0 0 1.333 4.982ZM23.574 26.116a5.988 5.988 0 1 0 0-11.976 5.988 5.988 0 0 0 0 11.976Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.663 5.032H20.579c-9.158 0-14.618 5.46-14.618 14.618v21.084c0 2.742.478 5.133 1.409 7.145 2.164 4.78 6.793 7.473 13.209 7.473h21.084c9.158 0 14.618-5.46 14.618-14.618V19.65c0-9.158-5.46-14.618-14.618-14.618ZM52.18 31.45c-1.963-1.686-5.133-1.686-7.095 0l-10.467 8.982c-1.962 1.686-5.133 1.686-7.095 0l-.855-.705c-1.787-1.56-4.63-1.71-6.643-.352l-9.41 6.315c-.553-1.408-.88-3.044-.88-4.956V19.65c0-7.095 3.749-10.844 10.844-10.844h21.084c7.095 0 10.844 3.749 10.844 10.844v12.077l-.327-.277Z"
  }))));
};
export default SvgGallery;